import { Button, Flex, Separator, Text } from '@chakra-ui/react';
import { observer } from 'mobx-react-lite';
import { useRouter } from 'next/navigation';
import { useCallback } from 'react';

import CartList from '@features/cart/CartList';
import { useStores } from 'stores/rootStore';

interface CartSummaryProps {
  onContinueShopping: () => void;
}

const CartSummary = ({ onContinueShopping }: CartSummaryProps) => {
  const { marketPlaceStore } = useStores();
  const router = useRouter();
  const isCartEmpty = marketPlaceStore.cart.length === 0;

  const handleContinueToCheckout = useCallback(() => {
    router.push(`/checkout/${marketPlaceStore.cartId}`);
  }, [marketPlaceStore.cartId, router]);

  return (
    <Flex flexDirection="column" gap={4} h="100%" w="100%" pb={4}>
      <Flex w="100%" overflowY="scroll" flex={1}>
        <CartList />
      </Flex>
      {marketPlaceStore.cartSize > 0 && (
        <>
          <Separator borderColor="border.light" />
          <Flex justifyContent="space-between">
            <Text>Subtotal</Text>
            <Text fontSize="lg" fontWeight="bold">
              GHS{marketPlaceStore.cartTotal}
            </Text>
          </Flex>
          <Separator borderColor="border.light" />
        </>
      )}
      <Flex flexDirection="column" gap={4}>
        <Button
          variant="outline"
          borderColor="border.light"
          onClick={onContinueShopping}
          _hover={{
            backgroundColor: 'button.secondary.hover',
          }}
        >
          Continue shopping
        </Button>
        <Button disabled={isCartEmpty} w="100%" onClick={handleContinueToCheckout}>
          Continue to checkout
        </Button>
      </Flex>
    </Flex>
  );
};

export default observer(CartSummary);
